import { useState, useEffect } from "react";

export default function RulesModal() {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    setShowModal(true);
  }, []);

  return (
    <>
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-3xl w-full overflow-auto max-h-[80vh]">
            <h2 className="text-lg font-bold text-gray-900 text-center mb-4">Event Rules & Guidelines</h2>
            <div className="space-y-6">
              <div>
                <h5 className="text-md font-semibold text-gray-900 mb-2">Registration and Participation</h5>
                <ol className="list-decimal list-inside space-y-2 md:pl-4">
                  <li className="text-sm text-gray-700 leading-relaxed">Participants must register in advance and submit their project titles with a brief description by the given deadline.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Each team should consist of 1–4 members. Individual participation may also be allowed depending on the rules.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Participants must present their institutional ID cards on the day of the exhibition.</li>
                </ol>
              </div>
              <div>
                <h5 className="text-md font-semibold text-gray-900 mb-2">Project Guidelines</h5>
                <ol start="4" className="list-decimal list-inside space-y-2 md:pl-4">
                  <li className="text-sm text-gray-700 leading-relaxed">Projects must be original and should not have been presented in any prior competitions.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">The project should be relevant to the theme (if any) of the exhibition.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Participants are responsible for arranging their materials, tools, and equipment. Only basic facilities like tables, electricity, or water will be provided by the organizers.</li>
                </ol>
              </div>
              <div>
                <h5 className="text-md font-semibold text-gray-900 mb-2">Setup and Display</h5>
                <ol start="7" className="list-decimal list-inside space-y-2 md:pl-4">
                  <li className="text-sm text-gray-700 leading-relaxed">Teams must set up their projects at the designated location within the allotted time. Latecomers may be disqualified.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Projects must display the title, team member names, and college name clearly.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">All exhibits must be secured to prevent accidents or damage during the exhibition.</li>
                </ol>
              </div>
              <div>
                <h5 className="text-md font-semibold text-gray-900 mb-2">Safety and Conduct</h5>
                <ol start="10" className="list-decimal list-inside space-y-2 md:pl-4">
                  <li className="text-sm text-gray-700 leading-relaxed">Projects must not pose any safety risks to participants, judges, or visitors (e.g., hazardous chemicals, sharp objects, open flames).</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Teams should be present at their stations throughout the event to explain and demonstrate their projects.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Respectful behavior and professional conduct toward judges, volunteers, and other participants are mandatory.</li>
                </ol>
              </div>
              <div>
                <h5 className="text-md font-semibold text-gray-900 mb-2">Evaluation</h5>
                <ol start="13" className="list-decimal list-inside space-y-2 md:pl-4">
                  <li className="text-sm text-gray-700 leading-relaxed">Projects will be judged based on creativity, scientific methodology, presentation, and relevance to the theme.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">The decision of the judges will be final and binding.</li>
                </ol>
              </div>
              <div>
                <h5 className="text-md font-semibold text-gray-900 mb-2">Other Important Rules</h5>
                <ol start="15" className="list-decimal list-inside space-y-2 md:pl-4">
                  <li className="text-sm text-gray-700 leading-relaxed">Teams must follow the event schedule, including setup and dismantling times.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Use of pre-made or plagiarized content will result in immediate disqualification.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Snacks or refreshments, if provided, should be consumed only in designated areas.</li>
                  <li className="text-sm text-gray-700 leading-relaxed">Emergency procedures, if required, must be adhered to promptly.</li>
                </ol>
              </div>
            </div>
            <div className="text-center mt-4">
              <button 
                onClick={() => setShowModal(false)} 
                className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
